const SKELETON_ELEMENT_ID = "app-loading-skeleton";
// brief delay so the skeleton fades out before it's removed
const SKELETON_REMOVE_DELAY_MS = 300;

/**
 * Hides and removes the #app-loading-skeleton element from the DOM.
 *
 * Pure DOM, no Redux — safe to call from anywhere, including the crash fallback
 * where the AppLoadingSkeletonRemover (which hides it via Redux) is unmounted.
 *
 * @returns a cleanup function that cancels the pending removal timer.
 */
export const removeAppLoadingSkeleton = (): (() => void) => {
  const el = document.getElementById(SKELETON_ELEMENT_ID);
  if (!el) return () => {};

  el.classList.add("hide-loading-skeleton");
  const timer = window.setTimeout(() => {
    el.remove();
  }, SKELETON_REMOVE_DELAY_MS);

  return () => window.clearTimeout(timer);
};
